import React, { Component } from "react";
import { MDBInput, MDBBtn, MDBTextArea } from "mdb-react-ui-kit";
import ModalPortal from "./ModalPortal";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import "./CommentItemModal.css";

const stripDataUrl = (dataUri) =>
  dataUri && String(dataUri).startsWith("data:image")
    ? String(dataUri).replace(/^data:image\/[a-zA-Z0-9+.+-]+;base64,/, "")
    : dataUri || "";

const toDataUrl = (b64) =>
  b64 ? (String(b64).startsWith("data:") ? b64 : `data:image/jpeg;base64,${b64}`) : "";

export default class CommentItemModal extends Component {
  constructor(props) {
    super(props);
    const incoming = props.item || {
      idComentario: null,
      authorName: "",
      origin: "",
      text: "",
      link: "",
      date: "",
      imageBase64: "",
    };

    this.state = {
      item: {
        idComentario: incoming.idComentario ?? null,
        authorName: incoming.authorName || "",
        origin: incoming.origin || "",
        text: incoming.text || "",
        link: incoming.link || "",
        date: incoming.date || "",
        imageBase64: stripDataUrl(incoming.imageBase64 || ""),
        imageUuid: incoming.imageUuid || null,
      },
    };
  }

  componentDidMount() {
    document.body.classList.add("modal-open");
  }
  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item !== this.props.item) {
      const incoming = this.props.item || {};
      const next = {
        idComentario: incoming.idComentario ?? null,
        authorName: incoming.authorName || "",
        origin: incoming.origin || "",
        text: incoming.text || "",
        link: incoming.link || "",
        date: incoming.date || "",
        imageBase64: stripDataUrl(incoming.imageBase64 || ""),
        imageUuid: incoming.imageUuid || null,
      };
      this.setState({
        item: next,
      });
    }
  }

  onField = (k, v) => this.setState((s) => ({ item: { ...s.item, [k]: v } }));

  buildPayload = () => {
    const out = { ...this.state.item };
    if (out.imageUuid) out.imageBase64 = null;
    return out;
  };

  handleDelete = () => {
    const payload = this.buildPayload();
    const safeLog = {
      idComentario: payload.idComentario,
      authorName: payload.authorName,
      origin: payload.origin,
      date: payload.date,
      hasImage: !!payload.imageBase64,
      link: payload.link,
      textPreview: (payload.text || "").slice(0, 60),
    };
    this.props.onDelete && this.props.onDelete(payload);
  };

  render() {
    const { onClose, onSave, onDelete } = this.props;
    const { item } = this.state;

    return (
      <ModalPortal>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center detail-modal-header">
              <h5 className="detail-modal-title mb-0">Editar comentario / recorte</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Cerrar" />
            </div>

            <div className="detail-modal-body">
              {/* Imagen (editable) */}
              <div className="cim-uploader">
                <MfmImageUploader
                  uuid={item.imageUuid || null}
                  appCode="MUGIN"
                  library="comentarios"
                  size="medium"
                  mediaFormat="16/9"
                  mediaFrameSize="320x180"
                  onUpload={(result) => this.setState((s) => ({ item: { ...s.item, imageUuid: result.uuid, imageBase64: null } }))}
                  onDelete={() => this.setState((s) => ({ item: { ...s.item, imageUuid: null } }))}
                />
              </div>

              {/* Campos editables */}
              <div className="detail-modal-section">
                <MDBTextArea
                  label="Texto del comentario"
                  rows={4}
                  className="mb-3"
                  value={item.text}
                  onChange={(e) => this.onField("text", e.target.value)}
                />

                <MDBInput
                  label="Autor"
                  className="mb-3"
                  value={item.authorName}
                  onChange={(e) => this.onField("authorName", e.target.value)}
                />

                <MDBInput
                  label="Origen (medio/propio)"
                  className="mb-3"
                  value={item.origin}
                  onChange={(e) => this.onField("origin", e.target.value)}
                />

                <MDBInput
                  label="Fecha"
                  type="date"
                  className="mb-3"
                  value={item.date}
                  onChange={(e) => this.onField("date", e.target.value)}
                />

                <MDBInput
                  label="Enlace (opcional)"
                  className="mb-3"
                  value={item.link}
                  onChange={(e) => this.onField("link", e.target.value)}
                />
              </div>
            </div>

            {/* Acciones */}
            <div className="cim-actions d-flex align-items-center">
              {onDelete && (
                <MDBBtn color="danger" outline onClick={this.handleDelete}>
                  Eliminar
                </MDBBtn>
              )}
              <div style={{ flex: 1 }} />
              <MDBBtn color="secondary" onClick={onClose}>
                Cancelar
              </MDBBtn>
              <MDBBtn className="mugin-btn-primary" onClick={() => onSave?.(this.buildPayload())}>
                Guardar
              </MDBBtn>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}
